(function () {
  'use strict';

  const APP_PROXY_URL = 'https://preorder-server-production.up.railway.app';

  document.addEventListener('DOMContentLoaded', () => {
    const selectors = document.querySelectorAll('.preorder-batch-selector');
    selectors.forEach(el => new PreorderSelector(el));
  });

  class PreorderSelector {
    constructor(el) {
      this.el = el;
      this.productId = el.dataset.productId;
      this.selectedBatch = null;
      this.batches = el.querySelectorAll('.preorder-batch--selectable');
      this.batchIdInput    = document.getElementById('preorder-batch-id-input');
      this.batchLabelInput = document.getElementById('preorder-batch-label-input');
      this.shipDateInput   = document.getElementById('preorder-ship-date-input');
      this.displayInput    = document.getElementById('preorder-display-input');
      this.addToCartBtn = document.querySelector('[data-add-to-cart], .product-form__submit, #AddToCart, button[name="add"]');
      this.init();
    }

    async init() {
      this.batches.forEach(batch => {
        batch.addEventListener('click', () => this.selectBatch(batch));
        batch.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') this.selectBatch(batch); });
      });
      const firstOpen = this.el.querySelector('.preorder-batch--selectable');
      if (firstOpen) this.selectBatch(firstOpen, { silent: true });
      await this.fetchSoldThrough();
      this.guardAddToCart();
    }

    selectBatch(batchEl, { silent = false } = {}) {
      this.batches.forEach(b => b.classList.remove('is-selected'));
      batchEl.classList.add('is-selected');
      this.selectedBatch = {
        id:       batchEl.dataset.batchId,
        label:    batchEl.dataset.batchLabel,
        shipDate: batchEl.dataset.shipDate,
        status:   batchEl.dataset.status
      };
      if (this.batchIdInput)    this.batchIdInput.value    = this.selectedBatch.id;
      if (this.batchLabelInput) this.batchLabelInput.value = this.selectedBatch.label;
      if (this.shipDateInput)   this.shipDateInput.value   = this.selectedBatch.shipDate;
      if (this.displayInput)    this.displayInput.value    = `${this.selectedBatch.label} (Pre-order)`;
      this.setCartAttributes();
      if (!silent) {
        batchEl.style.transform = 'scale(0.98)';
        setTimeout(() => { batchEl.style.transform = ''; }, 120);
      }
    }

    async fetchSoldThrough() {
      try {
        const res = await fetch(`${APP_PROXY_URL}/apps/preorder/batches?product_id=${this.productId}`);
        if (!res.ok) return;
        const data = await res.json();
        if (!data.enabled || !data.batches) return;
        data.batches.forEach(batch => {
          const badgeEl = this.el.querySelector(`.js-sold-pct[data-batch-id="${batch.id}"]`);
          if (badgeEl && batch.status === 'open') {
            badgeEl.textContent = `${batch.sold_through_pct}% Reserved`;
          }
          if (batch.is_sold_out) {
            const batchEl = this.el.querySelector(`[data-batch-id="${batch.id}"]`);
            if (batchEl) {
              batchEl.classList.remove('preorder-batch--selectable');
              batchEl.classList.add('preorder-batch--disabled');
              batchEl.removeAttribute('role');
              batchEl.removeAttribute('tabindex');
              const badgeWrapper = batchEl.querySelector('[data-badge]');
              if (badgeWrapper) {
                badgeWrapper.className = 'preorder-batch__badge badge--soldout';
                badgeWrapper.innerHTML = '<span class="badge-icon">🚀</span><span class="badge-text">Sold Out</span>';
              }
            }
          }
        });
      } catch (err) {
        console.warn('Preorder: Could not fetch sold-through data', err);
      }
    }

    setCartAttributes() {
      if (!this.selectedBatch) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            '_preorder_batch_id':    this.selectedBatch.id,
            '_preorder_batch_label': this.selectedBatch.label,
            '_preorder_ship_date':   this.selectedBatch.shipDate
          }
        })
      }).catch(err => console.warn('Preorder: cart attributes update failed', err));
    }

    guardAddToCart() {
      if (!this.addToCartBtn) return;
      const form = this.addToCartBtn.closest('form');
      if (!form) return;
      form.addEventListener('submit', (e) => {
        if (!this.selectedBatch) {
          e.preventDefault();
          e.stopPropagation();
          this.showBatchError();
          return false;
        }
        if (this.selectedBatch.status !== 'open') {
          e.preventDefault();
          e.stopPropagation();
          this.showBatchError('This batch is no longer available. Please select another.');
          return false;
        }
      });
    }

    showBatchError(msg = 'Please select a pre-order batch before adding to cart.') {
      let errorEl = this.el.querySelector('.preorder-error');
      if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.className = 'preorder-error';
        errorEl.style.cssText = 'color:#ef4444;font-size:0.85rem;margin-top:8px;font-weight:500;';
        this.el.appendChild(errorEl);
      }
      errorEl.textContent = msg;
      this.el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      setTimeout(() => { errorEl.textContent = ''; }, 4000);
    }
  }

  window.PreorderBatch = {
    getCurrentBatch() {
      const batchIdInput = document.getElementById('preorder-batch-id-input');
      const batchLabelInput = document.getElementById('preorder-batch-label-input');
      const shipDateInput = document.getElementById('preorder-ship-date-input');
      if (!batchIdInput?.value) return null;
      return {
        id: batchIdInput.value,
        label: batchLabelInput?.value,
        shipDate: shipDateInput?.value
      };
    },
    injectIntoCartPayload(payload) {
      const batch = this.getCurrentBatch();
      if (!batch) return payload;
      const properties = payload.properties || {};
      return {
        ...payload,
        properties: {
          ...properties,
          '_preorder_batch_id':    batch.id,
          '_preorder_batch_label': batch.label,
          '_preorder_ship_date':   batch.shipDate,
          'Pre-order Delivery':    `${batch.label} (Pre-order)`
        }
      };
    }
  };
})();